import { useCallback } from "react";
import { ScrollView, View, Text, StyleSheet, Linking } from "react-native";
import SEOHeaderTags from "../components/SEOHeaderTags";
import { PRIVACY_POLICY as privacyPolicy } from "../constants/privacyPolicy";
import { COLORS } from "../theme/colors";
import { STRINGS } from "../constants/strings";
import AppStore from "../storage/appStore";
import { logError } from "../platform";

const Terms = () => {
  const setErrorMessage = AppStore((state) => state.setErrorMessage);

  const handleEmailPress = useCallback(
    async (email) => {
      if (email) {
        try {
          await Linking.openURL(`mailto:${email}`);
        } catch (error) {
          logError("link_open_failed", {
            message: error.message,
            stack: error.stack,
            email,
          });
          setErrorMessage(STRINGS.failedToOpenLink);
        }
      }
    },
    [setErrorMessage]
  );

  return (
    <ScrollView contentContainerStyle={styles.container}>
      {privacyPolicy.map((item, index) => (
        <View key={index} style={styles.itemContainer}>
          <SEOHeaderTags style={styles.title} text={item.title} tag="h2" />
          <Text style={styles.text} maxFontSizeMultiplier={1.2}>
            {item.description}
          </Text>

          {item.list && (
            <View style={styles.listContainer}>
              {item.list.map((listItem, listIndex) => (
                <View key={listIndex} style={styles.listItem}>
                  <Text style={styles.bullet} maxFontSizeMultiplier={1.2}>
                    •
                  </Text>
                  <Text style={styles.listText} maxFontSizeMultiplier={1.2}>
                    {listItem}
                  </Text>
                </View>
              ))}
            </View>
          )}

          {item.numberedList && (
            <View style={styles.listContainer}>
              {item.numberedList.map((listItem, listIndex) => (
                <View key={listIndex} style={styles.listItem}>
                  <Text style={styles.number} maxFontSizeMultiplier={1.2}>
                    {listIndex + 1}.
                  </Text>
                  <Text style={styles.listText} maxFontSizeMultiplier={1.2}>
                    {listItem}
                  </Text>
                </View>
              ))}
            </View>
          )}

          {item.additionalText && (
            <Text style={[styles.text, styles.additionalText]} maxFontSizeMultiplier={1.2}>
              {item.additionalText}
            </Text>
          )}

          {item.list2 && (
            <View style={styles.listContainer}>
              {item.list2.map((listItem, listIndex) => (
                <View key={listIndex} style={styles.listItem}>
                  <Text style={styles.bullet} maxFontSizeMultiplier={1.2}>
                    •
                  </Text>
                  <Text style={styles.listText} maxFontSizeMultiplier={1.2}>
                    {listItem}
                  </Text>
                </View>
              ))}
            </View>
          )}

          {item.closingText && (
            <View style={styles.closingTextContainer}>
              <Text style={[styles.text, styles.closingText]} maxFontSizeMultiplier={1.2}>
                {item.closingText}
                <Text
                  style={styles.emailLink}
                  onPress={() => handleEmailPress(item.emailLink)}
                  maxFontSizeMultiplier={1.2}
                >
                  {item.emailLink}
                </Text>
                {item.closingTextAfterEmail}
              </Text>
            </View>
          )}
        </View>
      ))}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    width: "100%",
    maxWidth: 750,
    alignSelf: "center",
    paddingBottom: 50,
  },
  itemContainer: {
    backgroundColor: COLORS.background,
    paddingHorizontal: 20,
    marginHorizontal: 20,
    marginTop: 30,
    paddingTop: 10,
    paddingBottom: 30,
  },
  title: {
    fontSize: 21,
    padding: 5,
    paddingBottom: 10,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderColor: COLORS.borderDark,
    paddingLeft: 0,
  },
  text: {
    fontSize: 18,
    paddingTop: 10,
    lineHeight: 26,
  },
  listContainer: {
    paddingTop: 10,
  },
  listItem: {
    flexDirection: "row",
    paddingVertical: 4,
  },
  bullet: {
    fontSize: 18,
    lineHeight: 26,
    marginRight: 10,
    marginTop: 0,
  },
  number: {
    fontSize: 18,
    lineHeight: 26,
    marginTop: 0,
    minWidth: 25,
  },
  listText: {
    fontSize: 18,
    lineHeight: 26,
    flex: 1,
  },
  additionalText: {
    paddingTop: 15,
  },
  closingTextContainer: {
    paddingTop: 15,
  },
  closingText: {
    paddingTop: 0,
  },
  emailLink: {
    color: COLORS.primary,
    textDecorationLine: "underline",
  },
});

export default Terms;
